export default __webpack_public_path__ + "static/media/cgmfpfed_logo1-1.a336b3da.gif";